import 'flickity/dist/flickity.pkgd'
import axios from 'axios';

jQuery(document).ready(function() {

    let sections = jQuery('.pg-cards__section')

    sections.each( function( index ) {

        const cardsSlider = jQuery('.pg-cards__cards',this),
            cardsSlide = jQuery('.block', this)

        if (cardsSlider.length > 0 && cardsSlide.length > 1) {

            var carousel = cardsSlider.flickity({
                cellSelector: '.block',
                prevNextButtons: false,
                autoPlay: false, // Disable autoPlay since we'll use marquee
                pauseAutoPlayOnHover: false,
                freeScroll: true,
                wrapAround: true,
                pageDots: false,
                groupCells: true,
                contain: false,
                cellAlign: 'center',
                // lazyLoad: 2,
                draggable: true,
                percentPosition: true,
                setGallerySize: true,
                arrowShape: {
                    x0: 10,
                    x1: 60, y1: 50,
                    x2: 65, y2: 45,
                    x3: 20
                }
            })

            // Marquee effect implementation
            let requestId;
            let isPaused = false;
            let easingProgress = 1; // 0 = stopped, 1 = full speed
            let isEasing = false;
            let isPauseEasing = false;
            const flickityInstance = carousel.data('flickity');
            const targetSpeed = 0.4;
            const easingDuration = 60; // frames for easing (about 1 second at 60fps)
            const pauseEasingDuration = 30; // frames for pause easing (about 0.5 second at 60fps)
            
            // Set initial position to be 0
            flickityInstance.x = 0;

            // Start the marquee animation
            play();

            // Main function that 'plays' the marquee
            function play() {
                if (!isPaused || isPauseEasing) {
                    // Apply resume easing if we're transitioning from pause to play
                    if (isEasing && easingProgress < 1) {
                        easingProgress += 1 / easingDuration;
                        if (easingProgress >= 1) {
                            easingProgress = 1;
                            isEasing = false;
                        }
                    }
                    
                    // Apply pause easing if we're transitioning from play to pause
                    if (isPauseEasing && easingProgress > 0) {
                        easingProgress -= 1 / pauseEasingDuration;
                        if (easingProgress <= 0) {
                            easingProgress = 0;
                            isPauseEasing = false;
                            isPaused = true; // Actually pause after easing is complete
                        }
                    }
                    
                    // Ease-out cubic function for smooth acceleration/deceleration
                    const easedProgress = 1 - Math.pow(1 - easingProgress, 3);
                    const currentSpeed = targetSpeed * easedProgress;
                    
                    flickityInstance.x = flickityInstance.x - currentSpeed;
                    flickityInstance.settle(flickityInstance.x);
                }
                requestId = window.requestAnimationFrame(play);
            }

            // Main function to pause the animation
            function pause() {
                if (!isPaused && !isPauseEasing) {
                    isPauseEasing = true;
                }
            }

            // Main function to resume the animation
            function resume() {
                isPaused = false;
                isPauseEasing = false;
                isEasing = true;
                easingProgress = 0;
            }

            // Pause on mouse over / focusin
            cardsSlider[0].addEventListener('mouseover', pause, false);
            cardsSlider[0].addEventListener('focusin', pause, false);

            // Resume on mouse out / focusout
            cardsSlider[0].addEventListener('mouseout', resume, false);
            cardsSlider[0].addEventListener('focusout', resume, false);

            jQuery(".block").addClass("pageloaded");

            let vm = this

            carousel.on( 'dragEnd.flickity', function() {

                const progressionBarHolder = jQuery(this)[0].nextElementSibling
                const intro = jQuery(this)[0].previousElementSibling

                updateProgress(carousel, jQuery('.progression__bar__completed', progressionBarHolder), jQuery('.button--next',intro), jQuery('.button--previous',intro) )
            });

            updateProgress(carousel, jQuery('.progression__bar__completed', this), jQuery('.button--next', this), jQuery('.button--previous', this) )

            // previous
            jQuery('.button--previous', this).on( 'click', function() {
              carousel.flickity('previous');

              console.log(jQuery(this))
              updateProgress(carousel, jQuery('.progression__bar__completed', vm), jQuery('.button--previous', vm)[0].nextElementSibling, jQuery('.button--previous', vm) )
            });
            jQuery('.button--previous', this).on( 'keypress', function(e) {
                if(e.which == 13) {
                    carousel.flickity('previous');
                    setTimeout(() => {
                        const cardsSlide = jQuery('.block', vm)
                        updateProgress(carousel, jQuery('.progression__bar__completed', vm), jQuery('.button--previous', vm)[0].nextElementSibling, jQuery('.button--previous', vm) )
                        // cardsSlide.each(function( e ) {
                        //     // console.log('it happens?');
                        //     if( !jQuery(this).hasClass('is-selected') ){
                        //         jQuery(this).find('*').attr('tabindex', '-1')
                        //     }else{
                        //         jQuery(this).find('.button').attr('tabindex', '0')
                        //     }
                        // })
                    }, 500);
                }
            });
            // next
            jQuery('.button--next', this).on( 'click', function() {
                carousel.flickity('next');

                updateProgress(carousel, jQuery('.progression__bar__completed', vm), jQuery('.button--next', vm), jQuery('.button--next', vm)[0].previousElementSibling )
            });
            jQuery('.button--next', this ).on( 'keypress', function(e) {
                if(e.which == 13) {
                    carousel.flickity('next');
                    setTimeout(() => {

                        updateProgress(carousel, jQuery('.progression__bar__completed', vm), jQuery('.button--next', vm), jQuery('.button--next', vm)[0].previousElementSibling )

                        // const cardsSlide = jQuery('.block', vm)
                        // cardsSlide.each(function( e ) {
                        //     if( !jQuery(this).hasClass('is-selected') ){
                        //         jQuery(this).find('*').attr('tabindex', '-1')
                        //     }else{
                        //         jQuery(this).find('.button').attr('tabindex', '0')
                        //     }
                        // })

                    }, 500);
                }
            });
        }

    })

    function updateProgress(carousel, currentProgressBar, currentNextButton, currentPrevButton ){

        const selectedIndex = jQuery(carousel).data('flickity').selectedIndex;
        const slideCount = jQuery(carousel).data('flickity').slides.length;

        const progressPercentage = ((selectedIndex + 1) / slideCount) * 100

        currentProgressBar.css( 'width', `${progressPercentage}%` );

        if(currentNextButton){
            if(selectedIndex + 1 == slideCount){
                jQuery(currentNextButton).addClass('inactive-button')
            }else{
                jQuery(currentNextButton).removeClass('inactive-button')
            }
        }

        if(currentPrevButton){
            if(selectedIndex == 0){
                jQuery(currentPrevButton).addClass('inactive-button')
            }else{
                jQuery(currentPrevButton).removeClass('inactive-button')
            }
        }

    }

})
